import React, { useState, useRef, useEffect, useContext } from "react";

import BankImage from "../../../../assets/img/bankImage.png";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import SettingTable from "../ManageSettings/SettingTable";
import AuthContext from "../../.././../utils/secure-route/AuthContext";
import { ToastContainer } from "react-toastify";
import adjustbalance from "../../../../assets/Image/adjust balance .png";
import CloseIcon from "../../../../assets/Image/close.png";
import { useToastHandler } from "../../../common/ToastHandler";
import useFormattingUtils from "../../../../context/useFormattingUtils";
export default function GeneralLedgerBankLedger() {
  const [billDate, setBillDate] = useState("2024-09-20");
  const dateInputRef = useRef(null);
  const { user } = useContext(AuthContext);
  const { Post, Get } = useApi();
  const [bankLedger, setBankLedger] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const storeid = user.store;
  const { formatDate , formatCurrency } = useFormattingUtils();
  const { handleToast } = useToastHandler();
  const [bankBalances, setBankBalances] = useState({});
const [totalBalance, setTotalBalance] = useState(0);

const fetchBankBalances = async () => {
  try {
    const response = await Post("bankLedger");
    setBankBalances(response.data.total_current_balances);

  } catch (error) {
    console.error("Error fetching bank balances:", error);
    handleToast({
      type: "ERROR",
      message: "Failed to fetch bank balances."
    });
  }
};
  useEffect(() => {

    fetchBankBalances();
  }, []);
  const fetchBanks = async () => {
    try {
      const response = await Get("bank");
      const bankList = response?.results || [];
      setBanks(bankList);
    } catch (error) {
      console.error("Error fetching banks:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch banks.",
      });
    }
  };

const getBankLedger = async () => {
  if (!selectedBank || !startDate || !endDate) return;

  try {
    const requestData = {
      bank: selectedBank,
      start_date: startDate,
      end_date: endDate,
    };

    const response = await Post("bankLedger", requestData);
    if (response?.status === 200) {
      const bankCash = response?.data?.bank_cash || {};
      const ledgerArray = bankCash?.results || [];

      const balances = response?.data?.total_current_balances || {};
      const currentBalance = balances[selectedBank] || 0;
      setBankLedger(Array.isArray(ledgerArray) ? ledgerArray : []);
      setTotalBalance(currentBalance);
    } else {
      console.error("Unexpected response status:", response?.status);
    }
  } catch (error) {
    console.error("Error fetching bank ledger:", error);
    setBankLedger([]);
    setTotalBalance(0);
  }
};

  useEffect(() => {
    getBankLedger();
    fetchBanks();
  }, [selectedBank, startDate, endDate]);

const handleCashSubmit = async (e) => {
  e.preventDefault();

  try {
    const formData = new FormData(e.target);
    const payload = Object.fromEntries(formData.entries());
    payload.store = storeid;
    payload.type = "bank_ledger";

    const response = await Post("bankCashAdjustmentData", payload);

    if (response?.status === 200 || response?.status ===201) {

      setShowModal(false);

      handleToast({
        type: "SUCCESS",
        message: "Balance adjusted successfully!"
      });

      await getBankLedger();

      const balanceResponse = await Post("bankLedger");
      setBankBalances(balanceResponse.data.total_current_balances);

    } else {
      handleToast({
        type: "ERROR",
        message: "Failed to adjust balance. Please try again."
      });
    }
  } catch (error) {
    console.error("Error adjusting balance:", error);
    handleToast({
      type: "ERROR",
      message: "An error occurred while adjusting balance."
    });
  }
};
  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setBillDate(selectedDate);
    console.log("Selected date:", selectedDate);
  };

  const openDatePicker = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  const formattedBankLedger = bankLedger?.map((item) => ({
    ...item,
    date: item.date ? formatDate(item.date) : "N/A",
  }));
  const columns = [

    { header: "Date", field: "date" },
    { header: "Invoice Number", field: "invoice_no" },
    { header: "Debit", field: "debit" },
    { header: "Credit", field: "credit" },
    { header: "Current Balance", field: "current_balance" },
    { header: "Reason", field: "reason" },
  ];

  return (
    <>
      <ToastContainer />

      <>
        {Object.keys(bankBalances).length > 0 && (
          <div
            style={{
              maxWidth: "83%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "left",
              alignItems: "left",
              gap: "30px",

              margin: "0 auto",
              marginTop: "40px",
              padding: "30px",
              backgroundColor: "#ffffff",
              borderRadius: "40px",
              border: "1px solid #EBEAF2",
              boxShadow: "0px 2px 8px rgba(6, 12, 34, 0.039)",

              flexWrap: "wrap",
            }}
          >
            {Object.entries(bankBalances).map(([bankName, balance]) => (
              <div
                key={bankName}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "346px",
                  height: "166px",
                  marginLeft: "9px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#4A5546",
                  border: "1px solid #d0d7de",
                  fontFamily: "Arial, sans-serif",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    color: "#F4FFEE",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <h3
                    style={{ margin: "0", fontSize: "18px", color: "#F4FFEE" }}
                  >
                    {bankName}
                  </h3>
                  <p
                    style={{
                      margin: "8px 0 0",
                      fontSize: "14px",
                      color: "#F4FFEE",
                    }}
                  >
                    Current Balance: {formatCurrency(balance.toFixed(2))}
                  </p>
                </div>
                <div style={{ opacity: 1 }}>
                  <img
                    src={BankImage}
                    alt="Bank Icon"
                    style={{
                      width: "80px",
                      height: "80px",
                      filter: "brightness(1.9)",
                      opacity: 0.3,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </>

      <div className="">
        <div>
        <div className="responsive-box" >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="mb-1">Bank Ledger</h3>
              <button
                className=""
                onClick={toggleModal}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#FFAF32",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#000",
                  cursor: "pointer",
                  fontWeight: "bold",
                  gap: "8px",
                }}
              >
                {" "}
                Adjust Balance
                <img
                  src={adjustbalance}
                  alt="adjust balance Icon"
                  style={{ width: "20px", height: "20px", marginLeft: "18px" }}
                />
              </button>
            </div>

            <div style={{ display: "flex", gap: "0px", marginBottom: "20px" }}>
              { }
              <div style={{ position: "relative", width: "242px" }}>
                <select
                  style={{
                    boxSizing: "border-box",
                    width: "203px",
                    height: "47px",
                    background: "#FFFFFF",
                    border: "1px solid #DBDBDB",
                    borderRadius: "10px 10px 10px 10px",
                    padding: "5px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                  className="input-select"
                  name="bank"
                  value={selectedBank}
                  onChange={(e) => setSelectedBank(e.target.value)}
                  required
                >
                  <option value="">Select a bank</option>
                  {banks.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #DBDBDB",
                  borderRadius: "10px",
                  width: "400px",
                  padding: "5px",
                  background: "#FFFFFF",
                  gap: "8px",
                }}
              >
                { }
                { }

                { }
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    fontSize: "14px",
                    backgroundColor: "transparent",
                  }}
                />

                { }
                <span style={{ fontSize: "14px", fontWeight: "bold" }}>to</span>

                { }
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    fontSize: "14px",
                    backgroundColor: "transparent",
                  }}
                />

                { }
                { }
              </div>
            </div>

            <SettingTable
              data={formattedBankLedger}
              columns={columns}
              showFooter={true}
              showAction={false}
              showExport={true}
              showFilter={false}

            />

            {showModal && (
              <div className="modal-overlay" onClick={toggleModal}>
                <div
                  className="modal-container"
                  onClick={(e) => e.stopPropagation()}
                  style={{ width: "700px", borderRadius: "20px" }}
                >
                  <div className="modal-header" style={{ border: "none" }}>
                    <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                      Adjust Balance
                    </h5>

                    <img
                      src={CloseIcon}
                      alt="Close"
                      width="34"
                      height="34"
                      onClick={toggleModal}
                    />
                    { }
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleCashSubmit}>
                      <div
                        className="row justify-content-center"
                        style={{ margin: "0 -15px" }}
                      >
                        <div className="col-md-5" style={{ padding: "0 15px" }}>
                          <input
                            style={{
                              height: "52px",
                              width: "100%",
                            }}
                            type="date"
                            className="form-control-borderless"
                            name="date"
                            required
                          />
                        </div>

                        <div className="col-md-5" style={{ padding: "0 15px" }}>
                          <select
                            style={{
                              height: "52px",
                              width: "100%",
                            }}
                            className="input-select"
                            name="bank"
                            required
                          >
                            <option value="">Select a bank</option>
                            {banks.map((bank) => (
                              <option key={bank.id} value={bank.id}>
                                {bank.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-5" style={{ padding: "0 15px" }}>
                          <select
                            style={{
                              height: "52px",
                              width: "100%",
                            }}
                            className="input-select"
                            name="cash_type"
                            required
                          >
                            <option value="" disabled selected>
                              Select Cash Type
                            </option>
                            <option value="Business cash">Business Cash</option>
                            <option value="Gas cash">Gas Cash</option>
                            <option value="Lottery cash">Lottery Cash</option>
                          </select>
                        </div>

                        <div className="col-md-5" style={{ padding: "0 15px" }}>
                          <input
                            style={{
                              height: "52px",
                              width: "100%",
                            }}
                            type="number"
                            className="form-control-borderless"
                            placeholder="Amount"
                            name="amount"
                            min="0"
                            required
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: "20px" }}>
                        <div className="col-md-12 text-end">
                          <button
                            type="submit"
                            className="btn"
                            style={{
                              color: "white",
                              backgroundColor: "#282e26",
                              borderRadius: "50px",
                              width: "181px",
                              height: "45px",
                              fontWeight: "bold",
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}